import React, { useState } from 'react';
import { createPortal } from 'react-dom';

export const getInitials = (email) => {
  if (!email) return '??';
  const parts = email.split('@')[0].split('.');
  if (parts.length > 1) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return parts[0].substring(0, 2).toUpperCase();
};

export const getRandomColor = (email) => {
  const colors = ['#0A2A91', '#4834B7', '#7E6FD7', '#2C78E4', '#9C3FBA', '#5B21D6', '#1F4D99', '#8A4FFF', '#B641A8', '#2E97E6'];
  
  const hash = email.split('').reduce((acc, char) => {
    return char.charCodeAt(0) + acc;
  }, 0);
  
  return colors[hash % colors.length];
};

// UserCircleDisplay component to show email initials in circles
export const UserCircleDisplay = ({ users, maxDisplay = 4, circleSizeClass = "default" }) => {
  const [showAllUsers, setShowAllUsers] = useState(false);

  const toggleAllUsers = () => {
    setShowAllUsers(!showAllUsers);
  };

  return (
    <>
      <div className="d-flex align-items-center">
        {users.slice(0, maxDisplay).map((user, idx) => (
          <div 
            key={idx} 
            className={`user-circle user-circle--${circleSizeClass} d-flex align-items-center justify-content-center text-white fw-bold avatar-tooltip`}
            style={{ backgroundColor: getRandomColor(user.email) }}
            data-tooltip={user.email}
          >
            {getInitials(user.email)}
          </div>
        ))}
        
        {users.length > maxDisplay && (
          <div 
            className={`more-circle more-circle--default d-flex align-items-center justify-content-center ev-btn-blue-outline-round ev-bold-reg avatar-tooltip`}
            onClick={toggleAllUsers}
            data-tooltip="View all members"
          >
            +{users.length - maxDisplay}
          </div>
        )}
      </div>
      
      {/* All users popup */}
      {showAllUsers && createPortal(
        <div
          className="modal fade show d-block bg-dark bg-opacity-50"
          style={{ zIndex: 'var(--num-10000000000)' }}
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content ev-card-7 blur-background p-4 scrollable-element">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <p className="ev-med-p-blue mb-0">All Members</p>
                <button className="ev-btn-text-only-fill ev-btn-large" onClick={toggleAllUsers}>
                  <i className="bi bi-x-circle"></i>
                </button>
              </div>
              
              <div className="row">
                {users.map((user, idx) => (
                  <div key={idx} className="col-6 mb-4">
                    <div className="list-group-item d-flex align-items-center">
                      <div
                        className="more-circle more-circle--default d-flex align-items-center justify-content-center text-white fw-bold me-3"
                        style={{ backgroundColor: getRandomColor(user.email) }}
                      >
                        {getInitials(user.email)}
                      </div>
                      <span className="text-truncate ev-small-p-dark">{user.email}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
};